import { PatientProduct } from '../../../modules/patient/models/relationship/PatientProduct'
import { Product } from '../../../modules/product/models/Product'
import { getSampleTypeContainer } from '../../../container/sampleType-modules'
import { SampleTypeService } from '../../../modules/sampleType/services/SampleTypeService'
import { SAMPLETYPE_SERVICE_KEY } from '../../../modules/sampleType'
import { PatientOncologyDTO } from '../../../modules/patient/models/patientForm/PatientOncologyDTO'
import { useEffect, useState } from 'react'
import { useStyles } from '../Application.styles'
import { COLOR_PRIMARY } from '../../../routes/color-constants'
import { useTranslation } from 'react-i18next'
import { SampleType } from '../../../modules/sampleType/models/SampleType'
import { Query } from '../../../common/api/Query'
import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { emptySampleOncologyDTO } from 'modules/sampleType/models/sampleForm/SampleOncologyDTO'
import { format, isValid } from 'date-fns'
import {convertTimeToLocal, formatDate } from '../../../common/utils/DataFormatters'

type RouteProps = {
  id?: string
  navigate?: () => void
}

export type SampleOncologyProps = RouteProps & {
  patients: PatientOncologyDTO[]
  patientProduct: PatientProduct
  product: Product
  handleChangePatientProducts: (pp: PatientProduct, i: number) => void
  index: number
  edit?: boolean
}

const sampleTypeService = getSampleTypeContainer().get<SampleTypeService>(SAMPLETYPE_SERVICE_KEY)

export const SampleOncology = (props: SampleOncologyProps) => {
  const [patientNumber, setPatientNumber] = useState<number>(props.product.patientNumber || 0)
  const classes = useStyles({ color: COLOR_PRIMARY })
  const { t, i18n } = useTranslation()
  const [sampleType, setSampleType] = useState<SampleType[]>([])
  const [patientProduct, setPatientProduct] = useState<PatientProduct>(props.patientProduct)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    sampleTypeService.getFilteredListDB(new Query({})).subscribe((res) => {
      setSampleType(res.items)
      setIsLoading(false)
    })
  }, [])

  const handleChangeSample = (name: string, e: any, index: number) => {
    if (props.patients) {
      let p = props.patients[index]
      let pp = props.patientProduct

      if (p && p._sample) {
        if (name == '_typeSample') {
          p._sample._typeSample = e.target.value
          p._sample.typeSample = e.target.value
        } else if (name == '_sampleProvided') {
          p._sample._sampleProvided = e
          p._sample.sampleProvided = e
        } else if (name == '_metastasesDescription') {
          p._sample._metastasesDescription = e.target.value
          p._sample.metastasesDescription = e.target.value
        } else if (name == '_extractionDate') {
          p._sample._extractionDate = e
          p._sample.extractionDate = e
        } else if (name == '_sampleTumorCellularity') {
          p._sample._sampleTumorCellularity = e.target.value
          p._sample.sampleTumorCellularity = e.target.value
        } else if (name == '_code') {
          p._sample._code = e.target.value
          p._sample.code = e.target.value
        } else if (name == 'language') {
          pp.language = e.target.value
          pp._language = e.target.value
        }
        let patients = props.patients
        patients[index] = p

        //@ts-ignore
        let newProduct = Object.assign({ ...patientProduct }, { patientOncology: patients })
        //@ts-ignore
        setPatientProduct(newProduct)
        //@ts-ignore
        props.handleChangePatientProducts(newProduct, props.index)
      } else {
        let p = props.patientProduct.patientOncology[index]
        if (p && p._sample) {
          if (name == '_typeSample') {
            p._sample._typeSample = e.target.value
            p._sample.typeSample = e.target.value
          } else if (name == '_sampleProvided') {
            p._sample._sampleProvided = e
            p._sample.sampleProvided = e
          } else if (name == '_metastasesDescription') {
            p._sample._metastasesDescription = e.target.value
            p._sample.metastasesDescription = e.target.value
          } else if (name == '_extractionDate') {
            p._sample._extractionDate = e
            p._sample.extractionDate = e
          } else if (name == '_sampleTumorCellularity') {
            p._sample._sampleTumorCellularity = e.target.value
            p._sample.sampleTumorCellularity = e.target.value
          } else if (name == '_code') {
            p._sample._code = e.target.value
            p._sample.code = e.target.value
          } else if (name == 'language') {
            pp.language = e.target.value
            pp._language = e.target.value
          }
          let patients = props.patients
          patients[index] = p

          //@ts-ignore
          let newProduct = Object.assign({ ...patientProduct }, { patientOncology: patients })
          //@ts-ignore
          setPatientProduct(newProduct)
          //@ts-ignore
          props.handleChangePatientProducts(newProduct, props.index)
        }
      }
    }
  }

  const handleChangePatientsDate = (d: Date, index: number) => {
    if (props.patients) {
      let p = props.patients[index]

      if (!p._sample) {
        //@ts-ignore
        p._sample = emptySampleOncologyDTO()
      }

      p._sample._extractionDate = d

      let patients = props.patients
      patients[index] = p

      let newProduct = Object.assign({ ...patientProduct }, { patientOncology: patients })
      //@ts-ignore
      props.handleChangePatientProducts(newProduct, props.index)
      //@ts-ignore
      setPatientProduct(newProduct)
    }
  }


  return (
    <>
      {!isLoading ? (
        <Grid container direction="column">
          {[...Array(patientNumber)].map((_, index) => (
            <Grid container spacing={4} key={index} style={{ marginTop: '40px' }}>
              <Grid
                item
                xs={12}
                style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
                {t('dateAboutSample') + ' ' + (index + 1) + ' ' + t('for') + ' ' + (i18n.language ==
                'es'
                  ? props.product?.nameES
                  : props.product?.nameEN)}
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="filled" fullWidth>
                  <InputLabel id="typeSampleLabel">{t('typeSample') + '*'}</InputLabel>
                  <Select
                    labelId={'typeSampleLabel'}
                    id={'type'}
                    name={'type'}
                    onChange={(e) => handleChangeSample('_typeSample', e, index)}
                    value={
                      patientProduct.patientOncology[index] &&
                      patientProduct.patientOncology[index]?._sample?._typeSample
                    }>
                    {sampleType.map((elementST, indexST) => {
                      return (
                        <MenuItem key={indexST} value={elementST.idOdoo ? elementST.idOdoo : ''}>
                          {(i18n.language == 'es' ? elementST?.nameES : elementST?.nameEN)}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid container key={index} xs={12} style={{ marginTop: '1%' }}>
                <Grid item xs={2}>
                  {t('spMetastasis')}
                </Grid>
                <Grid item xs={3}>
                  <Checkbox
                    checked={
                      patientProduct.patientOncology[index] &&
                      patientProduct.patientOncology[index]._sample._sampleProvided == 0
                    }
                    onChange={(e) => handleChangeSample('_sampleProvided', 0, index)}
                    color="primary"
                  />
                  <p>{t('ffpeBiopsyTumor')}</p>
                </Grid>
                <Grid item xs={3}>
                  <Checkbox
                    checked={
                      patientProduct.patientOncology[index] &&
                      patientProduct.patientOncology[index]._sample._sampleProvided == 1
                    }
                    onChange={(e) => handleChangeSample('_sampleProvided', 1, index)}
                    color="primary"
                  />
                  <p>{t('ffpeBiopsy')}</p>
                </Grid>
                <Grid item xs={3}>
                  <Checkbox
                    checked={
                      patientProduct.patientOncology[index] &&
                      patientProduct.patientOncology[index]._sample._sampleProvided == 2
                    }
                    onChange={(e) => handleChangeSample('_sampleProvided', 2, index)}
                    color="primary"
                  />
                  <p>{t('periBlood')}</p>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '1%' }}>
                <TextField
                  id={`metastasesDescription-${index}`}
                  label={t('metastasisDescription')}
                  variant="filled"
                  className={classes.textField}
                  fullWidth
                  value={
                    patientProduct.patientOncology[index] &&
                    patientProduct.patientOncology[index]?._sample?._metastasesDescription
                  }
                  onChange={(e) => handleChangeSample('_metastasesDescription', e, index)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id={`-${index}`}
                  label={t('celuTumor')}
                  variant="filled"
                  className={classes.textField}
                  fullWidth
                  value={
                    patientProduct.patientOncology[index] &&
                    patientProduct.patientOncology[index]?._sample?._sampleTumorCellularity
                  }
                  onChange={(e) => handleChangeSample('_sampleTumorCellularity', e, index)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={`code-${index}`}
                  label={t('codeSample')}
                  variant="filled"
                  className={classes.textField}
                  fullWidth
                  value={
                    patientProduct.patientOncology[index] &&
                    patientProduct.patientOncology[index]?._sample?._code
                  }
                  onChange={(e) => handleChangeSample('_code', e, index)}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd/MM/yyyy"
                    value={
                      patientProduct.patientOncology[index] &&
                      convertTimeToLocal(patientProduct.patientOncology[index]._sample._extractionDate)
                    }
                    onChange={(date) => date && isValid(date) && handleChangePatientsDate(formatDate(date), index)}
                    label={t('doe')}
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        size: 'small',
                        required: true,
                        className: classes.width100,
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          ))}
        </Grid>
      ) : (
        <CircularProgress style={{ alignSelf: 'center' }} />
      )}
    </>
  )
}
